<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">缴费方式</div>
            <div class="colorright"></div>
        </div>
        <div class="cball">
            <div>
                <div class="bg-white" style="min-height: 470px;padding: 50px;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                   <div class="flex justify-between align-center flex-wrap">
                        <el-image class="qrimg" v-for="(item,index) in config.collect_code" :key="index" :src="item | addurl" fit="cover"></el-image>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default ({
    data() {
        return{
            config: ''
        }
    },
    methods:{
        getconfig(){
            this.$api.index.config().then(res=>{
                this.config = res.data;
            })
        },
    },
    created(){
        this.getconfig();
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }



.qrimg{
        /* height: 200px; */
        /* width: 400px; */
        width: 100%;
        margin-bottom: 15px;
        /* margin-right: 30px */
    }
    .qrimg:last-child{
        margin: 0
    }
</style>


// WEBPACK FOOTER //
// payment_way.vue?6c034822